/**
 * Number of applications by five Underwriting / Re-underwriting results, by whether the Insured Person is newly insured or insured through Migration
 */

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = [
		{ wpx: 400 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 10 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 03 - Number of applications by five Underwriting / Re-underwriting results, by whether the Insured Person is newly insured or insured through Migration"
	],
	["Status", "Standard Plan", "", "", "", "", "Flexi Plan", "", "", "", ""],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline"
	]
]

const rows = payload => [
	["Newly Insured", "", "", "", "", "", "", "", "", "", ""],
	[
		"Insured through Migration (who requires new application)",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		""
	]
]
